import API from '../../../helpers/request/api';

const api = () => new API();

const userRelatedDetails = (categoryIds) => {
  const query = {
    query: `{
      categories_by_ids(ids: [${categoryIds}]) {
        id
        status
        progress
        completed_at
        quantity_finished_posts
      }
    }`,
  };

  return api().get(query);
};

const fetchAll = (categoryId, projectId) => {
  const query = {
    query: `{
      available_categories_by_parent(
        category_id: ${categoryId},
        project_id: ${projectId}
      ) {
        id
        name
        status
        quantity_finished_posts
        completed_at
        scheduling_status
        has_availabe_categories(project_id: ${projectId})
        available
        progress
        available_posts_count
        scheduling_by_user {
          id
          open_date
          close_date
          days
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  userRelatedDetails,
  fetchAll,
};



// WEBPACK FOOTER //
// ./src/screens/Index/queries/categories.js